@let profile = identity();
@let selectedTenant = profile | selectedTenant;
@let tenantOptions = profile | getTenantOptions;
@let currentLanguageKey = languageService.currentLanguageKey;

<div class="festo-profile-link">
  <div (click)="openPopOver($event)" class="fwe-d-flex fwe-flex-row fwe-align-items-center">
    <i class="fwe-icon fwe-icon-people-user fwe-color-hero"></i>
    <div class="fwe-d-lg-block fwe-d-none fwe-ml-2">
      @if (profile) {
        <div class="profile-name">{{ profile.name }}</div>
      }
    </div>
  </div>
  <div>
    <div (smaWebClickOutside)="closePopOver()" class="festo-popover" [class.is-popover-visible]="profilePopOverVisible">
      <div class="festo-popover-pointer"></div>
      <div class="festo-popover-pointer-cover"></div>
      <div class="festo-popover-body">
        <div class="festo-popover-section">
          <!-- Round user icon  -->
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="64" height="64" class="fwe-mr-2 user-img">
            <path
              fill="var(--fwe-hero-gray)"
              d="M256 48C141.6 48 48 141.6 48 256s93.6 208 208 208 208-93.6 208-208S370.4 48 256 48zm0 62.4c34.3 0 62.4 28.1 62.4 62.4s-28.1 62.4-62.4 62.4-62.4-28.1-62.4-62.4 28.1-62.4 62.4-62.4zm0 300.4c-52 0-97.8-27-124.8-66.6 1-41.6 83.2-64.5 124.8-64.5s123.8 22.9 124.8 64.5c-27 39.5-72.8 66.6-124.8 66.6z"
            />
          </svg>

          <div class="user-info">
            <div class="fwe-d-flex">
              <div class="user-name">
                @if (profile) {
                  <b>{{ profile.name }}</b>
                }
              </div>
              <button type="button" class="fwe-float-right fwe-btn fwe-btn-link" (click)="onLogout()">{{ 'PROFILE.LOGOUT' | translate }}</button>
            </div>
            @if(profile) {
              <div class="login-name overflow-ellipsis" [attr.title]="profile.loginName">
                {{ profile.loginName }}
              </div>
            }
          </div>
        </div>

        <div class="festo-popover-section fwe-align-items-stretch fwe-pb-0">
          @if (currentLanguageKey) {
            <fng-select
              [label]="'BACKSTAGE.LANGUAGE.TITLE' | translate"
              [options]="languageService.languageOptions"
              [ngModel]="currentLanguageKey"
              (ngModelChange)="onLanguageChange($event)"
              class="w-100"
            />
          }
        </div>

        <div class="festo-popover-footer fwe-pb-0">
          @if (selectedTenant) {
            <fng-select
              [label]="'BACKSTAGE.ACCOUNT.TITLE' | translate"
              [options]="tenantOptions"
              [ngModel]="selectedTenant"
              (ngModelChange)="onTenantChange($event, selectedTenant)"
              class="w-100"
            />
          }
        </div>
      </div>
    </div>
  </div>
</div>
